import "../sass/main.scss";

import "slick-carousel/slick/slick";

import "./script-modal";

jQuery(document).ready(function () {
  jQuery('#menu-main-burger').click(function () {
    jQuery('#menu-main').slideToggle();
  });

  // Texture
  jQuery('.has-texture').prepend('<div class="texture texture-1"><img src="' + load_more_params_child.texture_url + '" alt=""/></div>');

  // > Accessibility
  jQuery('.pojo-a11y-toolbar-toggle').hide();

  jQuery('.js-accessibility').click(function (event) {
    event.preventDefault();

    if (jQuery(this).hasClass('active')) {
      jQuery(this).removeClass('active');
      jQuery('#pojo-a11y-toolbar').removeClass('pojo-a11y-toolbar--open');
      jQuery('.pojo-a11y-toolbar-link').click();
    } else {
      jQuery(this).addClass('active');
      jQuery('#pojo-a11y-toolbar').addClass('pojo-a11y-toolbar--open');
      jQuery('.pojo-a11y-toolbar-link').click();
    }

    return false;
  });

  jQuery('.pojo-a11y-toolbar-toggle').click(function (event) {
    event.preventDefault();

    jQuery('.pojo-a11y-toolbar-toggle').hide();

    return false;
  });
  // < Accessibility

  jQuery('.menu-search-form__button').click(function () {
    jQuery('.menu-search-form').fadeToggle();
  });
});

/*
 * ORGANIGRAMME
 */
jQuery(document).ready(function () {
  // jQuery('#nr-org-1 ul li > ul li > ul,#nr-org-2 ul li > ul .nr-org-level-3').hide();
  jQuery('#nr-org-1 ul li > ul .nr-org-level-3').hide();

  jQuery('.nr-org').scrollLeft((jQuery('.nr-org > ul').width() - jQuery('.nr-org').width()) / 2);

  jQuery('.nr-org ul li > .nr-org-block').each(function () {
    if (jQuery(this).next('ul').length > 0)
      jQuery(this).css('cursor', 'pointer').append('<div class="nr-org-fa"><i class="fa fa-angle-down" aria-hidden="true"></i></div>')
  });

  jQuery('.nr-org ul li > .nr-org-block').click(function () {
    jQuery(this).find('.fa').toggleClass('fa-angle-down').toggleClass('fa-angle-up');

    if (jQuery(this).next('ul').find('li').length > 1 && jQuery(window).width() > 767 && jQuery(window).width() < 1199) {
      var width;
      if (jQuery(this).next('ul').is(':visible'))
        width = jQuery('.nr-org > ul').width() - 300;
      else
        width = jQuery('.nr-org > ul').width() + 300;

      jQuery('.nr-org > ul').width(width);
    }
    jQuery(this).next('ul').slideToggle();
  });
});
// > ORGANIGRAMME
